<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import SidenavList from "./SidenavList.vue";
// import logo from "@/assets/img/logo-ct-dark.png";
// import logo from "@/assets/img/logo.png";
import logoWhite from "@/assets/img/logo-ct.png";

const store = useStore();
const layout = computed(() => store.state.layout);
const sidebarType = computed(() => store.state.sidebarType);
const darkMode = computed(() => store.state.darkMode);

// 动态获取环境变量中的 LOGO 路径
// const logo = require(`@/assets/img/${process.env.VUE_APP_LOGO}`);
const diy = JSON.parse(localStorage.getItem('TENANT_DIY'))
const logo = diy?diy.favicon:new URL(`@/assets/img/${process.env.VUE_APP_LOGO}`, import.meta.url).href;

console.log(' = logo', logo)

const primaryName = diy?diy.title:(process.env["VUE_APP_TITLE"] || "site.primaryName");

console.log(' - logo', logo, 'primaryName', primaryName)

</script>
<template>
  <div
    v-show="layout === 'default'"
    class="min-height-300 position-absolute w-100"
    :class="`${darkMode ? 'bg-transparent' : 'bg-success'}`"
  />

  <aside
    class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl fixed-start ms-3"
    :class="`${
        layout === 'landing' ? 'bg-transparent shadow-none' : ' '
      } ${sidebarType}`"
    id="sidenav-main"
  >
    <div class="sidenav-header">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>

      <router-link class="m-0 navbar-brand" to="/">
        <img
          :src="logo"
          class="navbar-brand-img h-100"
          alt="main_logo"
        />

        <span class="ms-2 font-weight-bold me-2">{{$t(primaryName)}}</span>
      </router-link>
    </div>

    <hr class="mt-0 horizontal dark" />

    <sidenav-list />
  </aside>
</template>
